import { getToken, getUserDataCookie } from '../../services/auth'

const privacity_url = `${process.env.REACT_APP_API_URI}/canais/paginas/privacidade`

export async function getPolicyDate() {
  const response = await fetch(privacity_url, {
    headers: {
      canal: 'gazin-ecommerce',
      'Content-Type': 'application/json;charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      authorization: 'Bearer ' + getToken(),
    },
  })

  if (!response.ok) {
    return null
  }

  const data = await response.json()

  return data.data_publicacao
}

export async function setPolicyData(
  setUserId: any,
  publicationDatePrivacyPolicy: any,
  setLoading: any,
  handleOpen: any,
  router: any
) {
  const userData = getUserDataCookie()

  if (!userData) return

  const acceptanceDate = userData.data_aceite_politica_privacidade

  setUserId(userData.id_consumidor)

  const dateOfAcceptance = new Date(acceptanceDate)
  const publicationDate = new Date(publicationDatePrivacyPolicy)

  const isShorterDate = dateOfAcceptance < publicationDate

  if (acceptanceDate === null || isShorterDate) {
    setLoading(false)
    handleOpen()
    return
  } else {
    setLoading(false)
    return router.push('/')
  }
}
